module.exports = "<p>\n  past-events works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/past-events/past-events.component.html
// module id = ./src/app/past-events/past-events.component.html
// module chunks = main